const providerContactsConfig = {
  view: "providerContacts",
}

export default providerContactsConfig
